/* flo-instructies.js: GEGENEREERD uit docs/demo-v2/src/js/86-in-stand.js door docs/shopify-port/pariteit/tools/port_js.py (Instructies: draaischijf en pictogrammen).
   Niet met de hand wijzigen: pas de demo of de vervangingen in port_js.py aan. Gegevens komen uit flo-pdp-core.js. */
/* 86-in-stand.js */
;(function(){
/* 86-in-stand.js: Instructies (in-stappen.html, in-plekken.html). Alleen op .page-instructies. Eigenaar: bouwer pagina's.
   1. De draaischijf. De tekening is de Globee van opzij: het bovenste deel heeft 3 markeringen op zijn onderrand, het
      onderste deel 1 (het driehoekje). De plek (radioknop "Waar komt hij?") bepaalt de stand: plafond 1, muur en tafel 3.
      Kies je een plek, dan gaat het bovenste deel omhoog, draait tot die markering boven het driehoekje staat en klikt
      vast. De markeringen lopen over de voorkant van de naad (ellips): x = 200 + 130 sin(t), y = 230 + 26 cos(t).
      Vanaf 1000px plakt de tekening naast de stappen en volgt hij de stap die in beeld is (fixronde 20 okt):
      data-dial="parts" helften los en verdraaid, "mark" markering boven het driehoekje, "klik" dicht met klik, "closed" dicht.
      De stap krijgt .is-now en zijn naam staat onder de tekening. Smaller speelt de schijf één keer voor als hij in beeld komt.
   2. De pictogrammen bij de vier plekken nemen hun houding aan als ze in beeld komen (.is-pre eraf, CSS doet de rest).
   Garanties: zonder JS staat de schijf op stand 1, dicht, en kiest CSS de stappen (:has). Bij reduced motion of
   ?motion=off springt de schijf meteen naar zijn stand en krijgt niets een begintoestand. Meten: FLO.inStand.state(). */
if (!document.querySelector('.page-instructies')) return;
var reduced = !!(window.FLO && FLO.motion && FLO.motion.reduced) || /[?&]motion=off\b/.test(location.search || '') ||
  (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
var vh = function(){ return window.innerHeight || document.documentElement.clientHeight; };
function inView(el){ var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < vh(); }

/* ---------- 1. draaischijf ---------- */
var dial = document.querySelector('[data-in-dial]');
var cap = dial && dial.querySelector('[data-in-cap]');
var marks = dial ? Array.prototype.slice.call(dial.querySelectorAll('.in-dial__mark')) : [];
var radios = Array.prototype.slice.call(document.querySelectorAll('input[name="in-plek"]'));
var steps = Array.prototype.slice.call(document.querySelectorAll('.in-route .in-st'));
var nowEl = dial && dial.querySelector('[data-in-now]');
var STAND = { plafond: 1, muur: 3, tafel: 3 };
var STEP = 40, LIFT = 34, OFF = 70;   /* graden tussen de markeringen (schematisch), hoe ver het bovenste deel omhoog gaat, verdraaiing als hij los is */
var S = { rot: 0, lift: 0 }, token = 0, played = false, touched = false, klikT = 0, cur = null, ticking = false;
var follow = window.matchMedia ? matchMedia('(min-width: 1000px)') : { matches: false };

function target(k){ return -(k - 1) * STEP; }
function plek(){ var r = radios.filter(function(x){ return x.checked; })[0]; return r ? r.value : 'plafond'; }
function stand(){ return STAND[plek()] || 1; }
function render(){
  cap.setAttribute('transform', 'translate(0 ' + (-S.lift).toFixed(2) + ')');
  marks.forEach(function(m){
    var k = +m.getAttribute('data-k'), t = (S.rot + (k - 1) * STEP) * Math.PI / 180;
    var c = Math.cos(t), x = 200 + 130 * Math.sin(t), y = 230 + 26 * c;
    var op = c < 0.2 ? 0 : Math.min(1, (c - 0.2) / 0.3);
    m.setAttribute('transform', 'matrix(' + Math.max(c, 0.01).toFixed(3) + ' 0 0 1 ' + x.toFixed(1) + ' ' + y.toFixed(1) + ')');
    m.setAttribute('opacity', op.toFixed(2));
    m.classList.toggle('is-on', Math.abs(S.rot + (k - 1) * STEP) < 1.5);
  });
}
function klik(){
  if (reduced) return;
  dial.classList.remove('is-klik'); void dial.getBoundingClientRect();   /* animatie opnieuw starten */
  dial.classList.add('is-klik'); clearTimeout(klikT);
  klikT = setTimeout(function(){ dial.classList.remove('is-klik'); }, 700);
}
var ease = {
  io: function(p){ return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; },
  out: function(p){ return 1 - Math.pow(1 - p, 3); },
  in: function(p){ return p * p; }
};
/* Tijdlijn: stappen {rot?, lift?, ms, e} of {call}; een nieuwe opdracht (token) breekt de lopende af */
function run(list, i, tok){
  if (tok !== token || i >= list.length) return;
  var st = list[i];
  if (st.call){ st.call(); run(list, i + 1, tok); return; }
  var from = { rot: S.rot, lift: S.lift }, t0 = null;
  function f(t){
    if (tok !== token) return;
    if (t0 === null) t0 = t;
    var p = Math.min(1, (t - t0) / st.ms), e = ease[st.e](p);
    if ('rot' in st) S.rot = from.rot + (st.rot - from.rot) * e;
    if ('lift' in st) S.lift = from.lift + (st.lift - from.lift) * e;
    render();
    if (p < 1) requestAnimationFrame(f); else run(list, i + 1, tok);
  }
  requestAnimationFrame(f);
}
/* Naar een toestand: parts (los, verdraaid), mark (los, markering boven het driehoekje), klik (dicht, met klik), closed */
function show(state, k){
  var tok = ++token, to = target(k);
  var want = state === 'parts' ? { rot: to + OFF, lift: LIFT } : state === 'mark' ? { rot: to, lift: LIFT } : { rot: to, lift: 0 };
  if (reduced){ S.rot = want.rot; S.lift = want.lift; render(); return; }
  var list = [], moved = false;
  if (Math.abs(S.rot - want.rot) > .5){
    if (S.lift < LIFT - 1) list.push({ lift: LIFT, ms: 240, e: 'out' });
    list.push({ rot: want.rot, ms: 520 + Math.abs(S.rot - want.rot) * 7, e: 'io' });
    moved = true;
  }
  var lastLift = moved ? LIFT : S.lift;
  if (Math.abs(lastLift - want.lift) > .5){ list.push({ lift: want.lift, ms: want.lift ? 240 : 190, e: want.lift ? 'out' : 'in' }); moved = true; }
  if (state === 'klik' && moved) list.push({ call: klik });
  run(list, 0, tok);
}
/* Vanaf 1000px: de stap waarvan de bovenkant de lijn op 45% van het scherm voorbij is, is de huidige */
function shown(){ return steps.filter(function(st){ return st.offsetParent !== null; }); }
function check(force){
  ticking = false;
  if (!follow.matches) return;
  var vis = shown(), line = vh() * 0.45, act = null;
  vis.forEach(function(st){ if (st.getBoundingClientRect().top <= line) act = st; });
  if (!act && vis[0] && vis[0].getBoundingClientRect().top < vh()) act = vis[0];
  if (!act || (act === cur && !force)) return;
  cur = act;
  steps.forEach(function(st){ st.classList.toggle('is-now', st === act); });
  if (nowEl) nowEl.textContent = (vis.indexOf(act) + 1) + '. ' + act.querySelector('h3').textContent.trim();
  played = true;
  show(act.getAttribute('data-dial') || 'closed', stand());
}
function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(function(){ check(false); }); } }
function setFollow(){
  dial.classList.toggle('is-follow', follow.matches);
  if (follow.matches){ cur = null; check(true); }
  else { cur = null; steps.forEach(function(st){ st.classList.remove('is-now'); }); show('closed', stand()); }
}
if (dial && cap && marks.length){
  radios.forEach(function(r){
    r.addEventListener('change', function(){
      if (!r.checked) return;
      touched = true; played = true;
      if (follow.matches){ cur = null; check(true); if (!cur) show('klik', stand()); }
      else show('klik', stand());
    });
  });
  S.rot = target(stand()); render();      /* een teruggezette keuze (terugknop) meteen tonen */
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (follow.addEventListener) follow.addEventListener('change', setFollow);
  setFollow();
  if (!reduced && !follow.matches && 'IntersectionObserver' in window && !inView(dial)){
    /* Smal voorspelen: alleen als de schijf bij het laden nog niet in beeld staat. Begintoestand pas dan: bovenste deel
       omhoog en verdraaid, zodat de markering van rechts naar voren draait en vastklikt. */
    S.rot = target(stand()) + OFF; S.lift = LIFT; render();
    var io = new IntersectionObserver(function(es){
      if (!es.some(function(e){ return e.isIntersecting; })) return;
      io.disconnect();
      if (played) return;
      played = true;
      setTimeout(function(){ if (!touched && !follow.matches) show('klik', stand()); }, 250);
    }, { threshold: 0.45 });
    io.observe(dial.querySelector('.in-dial__stage') || dial);
  }
}

/* ---------- 2. houding van de pictogrammen ---------- */
var ways = Array.prototype.slice.call(document.querySelectorAll('[data-in-way]'));
if (!reduced && ways.length && 'IntersectionObserver' in window){
  var wio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      wio.unobserve(e.target);
      var li = e.target.closest('[data-in-way]');
      requestAnimationFrame(function(){ li.classList.remove('is-pre'); li.classList.add('is-go'); });
    });
  }, { threshold: 0.6 });
  ways.forEach(function(li){
    var ico = li.querySelector('.ico'); if (!ico || inView(ico)) return;
    li.classList.add('is-pre'); wio.observe(ico);
  });
}

window.FLO = window.FLO || {};
FLO.inStand = { state: function(){
  return { plek: plek(), stand: dial ? stand() : null, now: cur ? steps.indexOf(cur) : -1, rot: +S.rot.toFixed(1), lift: +S.lift.toFixed(1), reduced: reduced,
    aligned: marks.filter(function(m){ return m.classList.contains('is-on'); }).map(function(m){ return +m.getAttribute('data-k'); }),
    pre: ways.filter(function(li){ return li.classList.contains('is-pre'); }).length };
} };

})();
